import React from "react";

export default function SuperAdminDashboardOverview() {
  return (
    <div className="custom-d-flex">
      <div className="mt-sa-overview-card">
        <h2 className="font-48-NunitoSans-600 mb-10">4</h2>
        <p className="font-24-NunitoSans-600 color-white-66">No of Clients</p>
      </div>
      <div className="mt-sa-overview-card">
        <h2 className="font-48-NunitoSans-600 mb-10">4</h2>
        <p className="font-24-NunitoSans-600 color-white-66">No of Agencies</p>
      </div>
      <div className="mt-sa-overview-card">
        <h2 className="font-48-NunitoSans-600 mb-10">4</h2>
        <p className="font-24-NunitoSans-600 color-white-66">No of Jobs</p>
      </div>
    </div>
  );
}
